import React, { useEffect, useState } from "react";
import { Tag, Space } from "antd";
import { getAnswerQueueStats, AnswerQueueStats } from "api/Reviews";

const OZON_MARKETPLACES = ["ozon", "ozon_fresh"];

const formatCount = (n: number, capped?: boolean) =>
  capped ? `${n}+` : String(n);

export const AnswerQueueStatsBar = (props: {
  marketplaces: string[];
}) => {
  const ozonSelected = props.marketplaces.some((m) =>
    OZON_MARKETPLACES.includes(m),
  );
  const show = props.marketplaces.length === 0 || ozonSelected;
  const ozonMp =
    props.marketplaces.find((m) => OZON_MARKETPLACES.includes(m)) ?? "ozon";
  const [stats, setStats] = useState<AnswerQueueStats | null>(null);

  useEffect(() => {
    if (!show) return;
    let cancelled = false;
    const load = () => {
      getAnswerQueueStats(ozonMp).then((data) => {
        if (!cancelled) setStats(data);
      });
    };
    load();
    const id = setInterval(load, 30_000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [ozonMp, show]);

  if (!show || !stats) return null;

  return (
    <div
      style={{
        padding: "8px 12px",
        background: "#fafafa",
        borderRadius: 8,
        marginBottom: 16,
        fontSize: 13,
      }}
    >
      <Space wrap size={[8, 4]}>
        <span style={{ fontWeight: 600 }}>Ozon — очередь ответов:</span>
        <Tag color="blue">
          В очереди: {formatCount(stats.counts.APPROVED ?? 0, stats.capped?.APPROVED)}
        </Tag>
        <Tag color="processing">
          Отправляется: {formatCount(stats.sendingNow, stats.capped?.INWORKED)}
        </Tag>
        <Tag color="orange">
          Переотправка: {formatCount(stats.counts.RESET ?? 0, stats.capped?.RESET)}
        </Tag>
        {stats.sendJobScheduled ? (
          <Tag color="purple">Send-job в BullMQ</Tag>
        ) : stats.pendingSend > 0 ? (
          <Tag color="red">Send-job не запланирован</Tag>
        ) : null}
      </Space>
    </div>
  );
};
